/**
 * @file 会员等级渐变色文字，多场景共用
 * @description 按会员等级取对应渐变色值渲染文字；LevelBadge、订阅管理卡片的套餐名均复用此组件
 */
import styles from './index.module.less';
import {createCx} from '@/utils/cx';
import {MemberLevelValue, type MemberLevel} from '@/services/commerce/type';

const cx = createCx(styles);

/** 会员等级 与 渐变色 class 映射 */
const LEVEL_GRADIENT_CLASS: Record<MemberLevel, string> = {
    [MemberLevelValue.FREE]: 'levelFree',
    [MemberLevelValue.STANDARD]: 'levelStandard',
    [MemberLevelValue.PRO]: 'levelPro',
    [MemberLevelValue.PREMIUM]: 'levelPremium',
    [MemberLevelValue.FLAGSHIP]: 'levelFlagship',
};

interface GradientLevelTextProps {
    memberLevel: MemberLevel;
    className?: string;
    children: React.ReactNode;
}

const GradientLevelText: React.FC<GradientLevelTextProps> = ({memberLevel, className, children}) => (
    <span className={cx('text', LEVEL_GRADIENT_CLASS[memberLevel] || 'levelFree', className)}>{children}</span>
);

export default GradientLevelText;
